<!--
 * @Author: your name
 * @Date: 2021-09-17 14:31:54
 * @LastEditTime: 2026-04-23 16:58:22
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\login\Register.vue
-->
<template>
  <div class="register">
    <div class="title flex-c-c">{{ $t('clr1') }}</div>
    <div class="user-form">
      <el-form :model="user" :rules="rules" ref="userForm" label-width="200px">
        <el-form-item :label="$t('clr2')" prop="user_name" :error="error.user_name">
          <el-input v-model="user.user_name" @change="(val) => verification('user_name', val)"></el-input>
        </el-form-item>
        <el-form-item :label="$t('clr3')" prop="referral_code" :error="error.referral_code">
          <div class="flex-c-c">
            <el-input v-model="user.referral_code" auto-complete="new-password"
              @change="(val) => verification('referral_code', val)"></el-input>
            <el-tooltip class="item" effect="dark" :content="$t('clr4')" placement="right">
              <i class="el-icon-question" style="font-size: 20px; margin-left: 2px;"></i>
            </el-tooltip>
          </div>
        </el-form-item>
        <el-form-item :label="$t('clr5')" prop="email" :error="error.email">
          <el-input type="email" v-model="user.email" @change="(val) => verification('email', val)"></el-input>
        </el-form-item>
        <el-form-item prop="email_code" :label="$t('clr6')">
          <el-input v-model="user.email_code" autocomplete="off">
            <template slot="append">
              <span @click="getVerification" :class="{ 'email-code': error.email_code }" class="email-code-hover"
                style="user-select: none;" v-if="codeTime <= 0">{{ $t('clr7') }}</span>
              <span class="email-code" style="user-select: none; max-width: 110px; text-align: center;"
                v-if="codeTime > 0">{{ codeTime }}{{ $t('clr8') }}</span>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('clr9')" prop="password">
          <el-input v-model="user.password" type="password" auto-complete="new-password"></el-input>
        </el-form-item>
        <el-form-item :label="$t('clr10')" prop="rpassword">
          <el-input v-model="user.rpassword" type="password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('clr11')" prop="group_name">
          <div class="flex-c-c">
            <el-input v-model="user.group_name"></el-input>
            <el-tooltip class="item" effect="dark" placement="right">
              <div slot="content">{{ $t('nlR04') }}</div>
              <i class="el-icon-question" style="font-size: 20px; margin-left: 2px;"></i>
            </el-tooltip>
          </div>
        </el-form-item>
        <el-form-item label-width="50px">
          <el-button type="primary" @click="submitForm('userForm')" round>{{ $t('clr12') }}</el-button>
        </el-form-item>
        <el-form-item label-width="30px">
          <div @click="setShowType" class="re-login">
            <span>{{ $t('clr13') }}?</span>&nbsp;
            <span style="color: #606266;">{{ $t('clr14') }}</span>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
// admin/signin/isLegal
// admin/signin/getEmailCode
import passwordStrength from '@/assets/scripts/passwordStrength.js'
export default {
  name: "Register",
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('clr15')));
      } else if (value !== this.user.password) {
        this.user.rpassword = "";
        callback(new Error(this.$t('clr16')));
      } else {
        callback();
      }
    };
    let passStrength = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('nlR01')));
      } else if (passwordStrength(value).strength < 3) {
        callback(new Error(this.$t('nlR02')))
      } else {
        callback();
      }
    };
    let groupName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('clr22')));
      } else if ((value.length < 8) || (!isNaN(Number(value)))) {
        callback(new Error(this.$t('nlR03')));
      } else {
        callback();
      }
    };
    return {
      codeTime: 0,
      intervalTime: null,
      error: {
        email: "",
        user_name: "",
        referral_code: "",
        email_code: true
      },
      user: {
        user_name: "",
        referral_code: "",
        email_code: "",
        email: "",
        password: "",
        rpassword: "",
        group_name: ""

      },
      rules: {
        user_name: [{ required: true, message: this.$t('clr17'), trigger: 'blur' }],
        referral_code: [{ required: true, message: this.$t('clr18'), trigger: 'blur' }],
        email_code: [{ required: true, message: this.$t('clr19'), trigger: 'change' }],
        email: [{ type: 'email', required: true, message: this.$t('clr20'), trigger: 'blur' }],
        password: [{required: true, validator: passStrength, trigger: 'blur' }],
        rpassword: [{required: true, validator: validatePass, trigger: 'blur' }],
        // group_name: [{ required: true, message: this.$t('clr22'), trigger: 'blur' }],
        group_name: [{required: true, validator: groupName, trigger: 'blur' }],
      }
    }
  },
  methods: {
    setShowType() {
      this.$emit("setShowType");
    },
    // referralLegal(val) {
    //   this.$http.post("/admin/signin/isLegal", { key: 'referral_code', value: val }, res => {
    //     if (!res) {
    //       this.errorAuthCode = "推荐码不存在，请重新获取。";
    //     } else {
    //       this.errorAuthCode = "";
    //     }
    //   });
    // },
    // userNameLegal(val) {
    //   this.$http.post("/admin/signin/isLegal", { key: 'email', value: val }, res => {
    //     if (!res) {
    //       this.errorUserName = "用户名已注册，请重新输入!";
    //     } else {
    //       this.errorUserName = "";
    //     }
    //   });
    // },
    // userEmailLegal(val) {
    //   this.$http.post("/admin/signin/isLegal", { key: 'user_name', value: val }, res => {
    //     if (!res) {
    //       this.errorUserName = "用户名已注册，请重新输入!";
    //     } else {
    //       this.errorUserName = "";
    //     }
    //   });
    // },
    verification(key, value) {
      this.$http.post("/admin/signin/isLegal", { key, value }, res => {
        console.log(res);
        if (res.status) {
          this.error[key] = res.tips;
        } else {
          this.error[key] = "";
          key === 'email' && (this.error.email_code = false);
        }
      });
    },
    getVerification() {
      if (this.error.email_code) {
        return;
      }
      this.codeTime = 120;
      this.$http.post("/admin/signin/getEmailCode", { recipients: this.user.email, timeout: this.codeTime }, () => {
        this.$msg({ message: this.$t('clr22'), type: "success", showClose: true });
      });
      this.intervalTime = setInterval(() => {
        if (this.codeTime > 0) {
          this.codeTime -= 1
        } else {
          clearInterval(this.intervalTime);
        }
      }, 1000);
    },
    //   user_name: this.addForm.name,
    // referral_code: this.addForm.authCode,
    // email: this.addForm.email,
    // pwd: encodeURIComponent(JSON.stringify([this.addForm.pass, this.addForm.checkPass])),
    // group_name: this.addForm.grouping,
    // email_code: this.addForm.verificationCode
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let { user_name, referral_code, email, group_name, email_code } = this.user;
          let pwd = encodeURIComponent(JSON.stringify([this.user.password, this.user.rpassword]));
          this.$http.post("/admin/signin/signIn", { user_name, referral_code, email, pwd, group_name, email_code }, (res) => {
            const { status, tips } = res;
            if (status !== 1 && status !== undefined) {
              this.$msg({ message: tips, type: "error", showClose: true });
              return;
            }
            this.$msg({ message: "账号注册成功!", type: "success", showClose: true });
            this.setShowType();
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  computed: {
    isVerifin() {
      return this.error.email && this.error.user_name && this.error.referral_code;
    }
  },
}
</script>

<style lang="scss" scoped>
.register {
  background-color: #fff;
  padding-bottom: 20px;
  border-radius: 8px;
  width: 600px;
  overflow: hidden;

  .title {
    height: 50px;
    font-size: 20px;
    color: #fff;
    // background-image: linear-gradient(270deg,
    //     #86eae7 0%,
    //     #4cccf0 45%,
    //     #11adf8 100%),
    //   linear-gradient(#ffffff, #ffffff);
    // background-blend-mode: normal, normal;
    background-color: var(--theme-color-customized-1);
  }

  .user-form {
    padding-right: 30px;
    padding-top: 20px;
    background-color: #fff;

    .el-form-item+.el-form-item {
      margin-top: 20px;
    }

    /deep/ .el-input-group__append {
      border-radius: 0px 20px 20px 0px;
      padding: 0 6px;
      text-align: center;
      width: 100px;
    }

    .re-login {
      text-align: center;
      line-height: 10px;
      cursor: pointer;
    }

    .email-code {
      cursor: not-allowed;
    }

    .email-code-hover {
      cursor: pointer;
    }
  }
}
</style>